/* eslint-disable import/prefer-default-export */
import { configureStore as createReduxStore } from '@reduxjs/toolkit';
// import thunkMiddleware from 'redux-thunk';
import { thunk as thunkMiddleware} from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from 'reducers';
import { ENABLE_REDUX_LOGGER } from 'config';

const loggerMiddleware = createLogger();

export function configureStore(preloadedState = {}) {
  const middlewares = [thunkMiddleware];

  if (ENABLE_REDUX_LOGGER) {
    middlewares.push(loggerMiddleware);
  }

  const store = createReduxStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middlewares),
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState,
  });

  return store;
}
